<template>
    <div class="page-container">
        <div class="purchase-status-block">
            <div class="status-text">
                <template v-if="pageData.status == 1">
                    <div class="status">待审核</div>
                    <div class="status-aside">您的补款单财务正在审核,入账后您的账户数据即可更新</div>
                </template>
                <template v-if="pageData.status == 2">
                    <div class="status">审核通过</div>
                    <div class="status-aside">您的补款单已经审核通过,且御粮账户余额已经更新</div>
                </template>
                <template v-if="pageData.status == 3">
                    <div class="status">审核拒绝</div>
                    <div class="status-aside">您的补款申请失败,若有疑问请联系客服处理</div>
                </template>
                
            </div>
            <img src="../../assets/icon-purchase-succ.png" class="status-pic">
        </div>
        <div class="page-bottom">
            <!-- 补款信息 -->
            <div class="purchase-block">
                <div class="block-title">补款信息</div>
                <div class="info-block">
                    <div class="info-item">
                        <span>补款流水号</span>
                        <span>{{pageData.seq}}</span>
                    </div>
                    <div class="info-item">
                        <span>补款申请时间</span>
                        <span>{{pageData.createTime | formatCreatetime}}</span>
                    </div>
                    <div class="info-item">
                        <span>审核入账时间</span>
                        <span>{{pageData.auditTime}}</span>
                    </div>
                    <div class="info-item">
                        <span>补款总金额(元)</span>
                        <span>{{pageData.amount}}</span>
                    </div>
                    <div class="info-item">
                        <span>实际到账(元)</span>
                        <span>{{pageData.actualAmount}}</span>
                    </div>
                </div>
            </div>
            <!-- 转账信息 -->
            <div class="transfer-block" v-if="pageData.voucher.length > 0">
                <div class="block-title">转账信息</div>
                <div class="img-list">
                    <img :src="item" alt="" style="border-radius:4px;" v-for="(item,index) in picList" :key="index">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast} from 'vant'

export default {
    data(){
        return{
            pageData:{},
            picList:[],
        }
    },
    components:{
        [Toast.name]:Toast
    },
    activated(){
        $http({
            method:'post',
            data:{
                orderId:this.$route.params.orderId,
            },
            url:config.api.replenishmentDetail
        }).then(res=>{
            if(res.errno == 0){
                this.pageData=res.data;
                this.picList=res.data.voucher.split(',')
            }else{
                Toast(res.errmsg);
            }
        })
    },
    methods:{
        
    }
}
</script>

<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.page-container{
    min-height:100vh;
    background:#fafafa;
    .purchase-status-block{
        padding:20px 36px;
        background: linear-gradient(110deg, #3CA7FE 0%, #3088F5 100%);
        display: flex;
        justify-content: space-between;
        align-items: center;
        .status-text{
            width:230px;
            color:#fff;
            .status{
                font-size: 16px;
                line-height: 22px;
                margin-bottom: 4px;
            }
            .status-aside{
                font-size: 12px;
                line-height: 16px;
            }
        }
        .status-pic{
            width:60px;
            height:60px;
        }
    }
    .page-bottom{
        padding:10px;
        .purchase-block{
            background:#fff;
            margin-bottom: 10px;
            .block-title{
                font-size: 14px;
                color:#333;
                padding:15px;
                padding-bottom: 0;
            }
            .info-block{
                padding:15px;
                .info-item{
                    color:#666;
                    line-height: 18px;
                    padding:4px 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 13px;
                    &>span{
                        &:last-child{
                            text-align: right;
                            color:#333;
                        }
                    }
                }
            }
        }
        .transfer-block{
            background:#fff;
            padding:15px;
            .block-title{
                font-size: 14px;
                color:#333;
                margin-bottom: 15px;
            }
            .img-list{
                @include flex-between();
                flex-wrap: wrap;
                &>img{
                    width:100px;
                    height:100px;
                    margin-bottom: 15px;
                }
            }
        }
    }
    
}
</style>